import type { ComponentType, ClassAttributes, ImgHTMLAttributes } from 'react';

import { styled, type StyledProps } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const RecentWorkItemIcon: ComponentType<
	ClassAttributes<HTMLImageElement> & ImgHTMLAttributes<HTMLImageElement> & StyledProps
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.img({
	borderRadius: token('radius.small', '3px'),
	display: 'flex',
	flexShrink: 0,
	width: token('space.300'),
	height: token('space.300'),
	marginTop: token('space.100'),
	marginBottom: token('space.100'),
});
